var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M117.946 35a28.41 28.41 0 0 1 20.092 8.323l101.414 101.413c7.397 7.398 7.397 19.392 0 26.789l-67.927 67.927c-7.397 7.397-19.391 7.397-26.789 0L43.323 138.038A28.41 28.41 0 0 1 35 117.946v-45.06C35 51.962 51.962 35 72.886 35zM90 65c-13.807 0-25 11.193-25 25s11.193 25 25 25 25-11.193 25-25-11.193-25-25-25"
})));
export default SvgTag;